import { createAsyncThunk } from '@reduxjs/toolkit';
import submit_message from 'functions/server/submit_message.js';
import join_email_list from 'functions/server/join_email_list.js';
import submit_bug_report from 'functions/server/submit_bug_report.js';
import download_sample_table from 'functions/server/download_sample_table.js';

export const submitMessage = createAsyncThunk('posts/submitMessage', async(payload, {rejectWithValue}) => {
  const response = await submit_message(payload)
  if (response === 'success') {
    return 'success'
  } else {
    return rejectWithValue('Exception: ' + response)
  }
});

export const joinEmailList = createAsyncThunk('posts/joinEmailList', async(payload, {rejectWithValue}) => {
  /*
  This function will submit an email to the join email list server. It will return 'success' if the email was successfully submitted.

  Args:
    payload: Object with the following
      email: String, the email to submit
      source: String, the source of the request such as 'API'
      name (optional): String, the name of the person requesting to join the email list
      organization (optional): String, the organization of the person requesting to join the email list
      message (optional): String, a message to include with the email
  */
  if (!payload.email) {
    return rejectWithValue('No email provided')
  }
  if (!payload.email.includes('@')) {
    return rejectWithValue('Invalid email')
  }
  if (!payload.source) {
    return rejectWithValue('No source provided')
  }
  const response = await join_email_list(payload)
  if (response === 'success') {
    return 'success'
  } else {
    return rejectWithValue('Exception: ' + response)
  }
});

export const submitBugReport = createAsyncThunk('posts/submitBugReport', async(payload, {rejectWithValue}) => {
  const response = await submit_bug_report(payload)
  if (response === 'success') {
    return 'success'
  } else {
    return rejectWithValue('Exception: ' + response)
  }
});

export const downloadSampleTable = createAsyncThunk('posts/downloadSampleTable', async(payload, {getState, rejectWithValue}) => {
  const tableName = payload.tableName;
  const state = getState();
  if (!tableName) {
    return rejectWithValue('No table name provided')
  }
  const responseJson = {
    'tableName': tableName,
    'columns': Object.keys(state.inputData.present.tableSettings[tableName]['isViewable']).filter(column => state.inputData.present.tableSettings[tableName]['isViewable'][column])
  }
  // download_sample_table resolves on success and throws on a failed request.
  // The old code compared its (always-undefined) return value to 'success', so a
  // successful download always fell through to the rejection branch.
  try {
    await download_sample_table(responseJson)
    return 'success'
  } catch (err) {
    return rejectWithValue('Exception: ' + (err?.message || err))
  }
});
